/**
 * this is your application conf, will be used in both client and server
 *
 */
const spCookieKey = '_sp'
const secretDashboardCookieKey = '__sdb'
const oktaAtCookieKey = 'okta_at'
const oktaItCookieKey = 'okta_it'
const seCookieKey = '_se'
const yahooYCookieKey = 'Y'
const yahooTCookieKey = 'T'

const COOKIE_TYPE = {
  SP: 'spCookie',
  SDB: 'sdbCookie',
  SE: 'seCookie'
}
const COOKIE_KEY_MAP = {
  spCookie: spCookieKey,
  sdbCookie: secretDashboardCookieKey,
  oktaAtCookie: oktaAtCookieKey,
  oktaItCookie: oktaItCookieKey,
  seCookie: seCookieKey,
  yahooYCookie: yahooYCookieKey,
  yahooTCookie: yahooTCookieKey
}

const appConf = {
  timezone: 'Asia/Taipei',
  serviceGroup: 'app',
  cdn: 'https://img.yec.tw',
  publicPathProd: '/zq/sp/frontend/', // webpack bundled path
  staticsDir: '/statics', // express serve static content from the folder
  staticsVersion: '20190719', // folder name in s.yimg. should modify if any static files changed. build.sh will parse this line
  reserviceUrlPath: '/fe/_reservice_/',
  mobileWebUrlPath: '/mobile',
  desktopWebUrlPath: '/desktop',
  sellerWebUrlPath: '/seller',
  spCookieKey,
  seCookieKey,
  secretDashboardCookieKey,
  oktaAtCookieKey,
  oktaItCookieKey,
  yahooYCookieKey,
  yahooTCookieKey,
  cookieType: COOKIE_TYPE,
  cookieKeyMap: COOKIE_KEY_MAP,
  featureConfCacheKey: 'FEATURE_CONF',
  whiteListedCookie: [spCookieKey, secretDashboardCookieKey, oktaAtCookieKey, oktaItCookieKey],
  sellerLoginWhiteListedCookie: [oktaAtCookieKey, oktaItCookieKey, yahooYCookieKey, yahooTCookieKey],
  sellerWhiteListedCookie: [seCookieKey, oktaAtCookieKey, oktaItCookieKey, yahooYCookieKey, yahooTCookieKey],
  favicon: 'tw.buy.yahoo.com/favicon.ico'
}

appConf.staticsPathFull = appConf.cdn + appConf.publicPathProd + appConf.staticsVersion + '/'

module.exports = appConf
